<template>
	<div>
		<!-- 顶部广告图 -->
		<section class="banner">
			<img v-if="workplaceTopAd" class="banner-img" :src="workplaceTopAd" />
		</section>

		<!-- 状态数字 -->
		<!-- <teacher-stats
			v-if="$store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.TEACHER.value"
		/>
		<school-admin-stats
			v-if="$store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.SCHOOL_ADMIN.value"
		/>
		<bureau-admin-stats
			v-if="$store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.BUREAU_ADMIN.value"
		/> -->

		<platform-admin-stats
			v-if="
				$store.state.user.userInfo &&
				($store.state.user.userInfo.type == $api.account.types.PLATFORM_ADMIN.value ||
					$store.state.user.userInfo.type == $api.account.types.OTHER.value)
			"
		/>

		<!-- 快捷方式 -->
		<!-- <quick-start v-if="quickActions.length > 0" :items="quickActions" class="quickaction" /> -->

		<!-- 学生：个人评价 -->
		<!-- <div
			v-if="$store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.STUDENT.value"
			class="evaluation-sheet-block block"
		>
			<block-header title="结构化评价指标">
				<el-form :inline="true">
					<el-form-item style="margin: 0;">
						<el-select v-model="student.currentSubjectTable" placeholder="选择切换学科" @change="onChangeSubjectTable">
							<el-option
								v-for="item in student.classSubject"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option> </el-select></el-form-item
					><el-form-item style="margin: 0 0 0 20px;">
						<el-select
							v-model="student.currentEvaluationTable"
							placeholder="选择切换学期"
							@change="onChangeEvaluationTable"
						>
							<el-option
								v-for="(item, index) in student.evalationTables"
								:key="item.value + index"
								:label="item.label"
								:value="item.value"
							></el-option> </el-select></el-form-item
				></el-form>
			</block-header>

			<evaluation-sheet
				:data="student.evaluationData"
				:past-semester="student.currentEvaluationTable != student.evalationTables[0].value"
			/>
			<student-performance-list :subject-id="student.currentSubjectTable" />
		</div> -->

		<!-- 简明待处理列表区 -->
		<!-- 学生 -->
		<!-- <student-todo-list
			v-if="$store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.STUDENT.value"
		/> -->
		<!-- 老师 -->
		<!-- <teacher-todo-list
			v-if="
				($store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.TEACHER.value) ||
				($store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.SCHOOL_ADMIN.value) ||
				($store.state.user.userInfo && $store.state.user.userInfo.type == $api.account.types.BUREAU_ADMIN.value)
			"
		/> -->
	</div>
</template>
<script>
import QuickStart from '@/components/QuickStart.vue'
import StudentTodoList from './CompStudentLists'
import TeacherTodoList from './CompTeacherLists'
import TeacherStats from './CompTeacherStats'
import SchoolAdminStats from './CompSchoolAdminStats'
import BureauAdminStats from './CompBureauAdminStats'
import PlatformAdminStats from './CompPlatformAdminStats'
import EvaluationSheet from '../EvaluationSheet/CompEvaluationSheet'
import StudentPerformanceList from '../StudentPerformance/StudentPerformanceList'
import ApiClient from '@midipro/js-api'

export default {
	components: {
		QuickStart,
		StudentTodoList,
		TeacherTodoList,
		TeacherStats,
		EvaluationSheet,
		SchoolAdminStats,
		BureauAdminStats,
		PlatformAdminStats,
		StudentPerformanceList
	},
	data() {
		return {
			workplaceTopAd: null,
			quickActions: [],
			allSemester: null,
			student: {
				evaluationData: {},
				currentEvaluationTable: null,
				currentSubjectTable: null,
				evalationTables: [],
				classSubject: null
			}
		}
	},
	mounted() {
		// if (
		// 	this.$store.state.user.userInfo &&
		// 	this.$store.state.user.userInfo.type !== this.$api.account.types.PLATFORM_ADMIN.value
		// ) {
		// 	this.$router.push('/workbench/classgrade_mgn')
		// }
		switch (this.$store.state.user.userInfo.type) {
			case this.$api.account.types.PLATFORM_ADMIN.value:
				// this.$router.push('/workbench/classgrade_mgn')
				break
			case this.$api.account.types.TEACHER.value:
				this.$router.push('/workbench/classgrade_mgn')
				break
			case this.$api.account.types.SCHOOL_ADMIN.value:
				this.$router.push('/workbench/classgrade_mgn')
				break
			default:
		}
	},
	async created() {
		let api = new ApiClient()
		// 请求更新顶部广告图
		// this.$api.ad
		// 	.list({
		// 		filterBy: {
		// 			type: this.$api.ad.types.GENERIC_WORKPLACE_CAROUSEL.value
		// 		}
		// 	})
		// 	.then(res => (this.workplaceTopAd = res.data[Math.floor(Math.random() * res.data.length)].image))
		switch (this.$store.state.user.userInfo.type) {
			case this.$api.account.types.STUDENT.value: {
				this.quickActions = [
					{
						to: {
							name: 'declarationAdd'
						},
						title: '提交申报',
						background: '#219AA7'
					},
					{
						to: {
							name: 'studentTest'
						},
						title: '快速测练',
						background: '#35C1B1'
					},
					{
						to: {
							name: 'personalCenter'
						},
						title: '个人中心',
						background: '#21A74A'
					}
				]

				//索取学科列表
				this.student.classSubject = this.$store.state.user.userInfo.student.class_grade.subjects
				//默认选中第一个
				if (this.student.classSubject && this.student.classSubject.length)
					this.student.currentSubjectTable = this.student.classSubject[0].id

				// 请求最新的评估表
				// 根据学科生成评估表
				this.student.classSubject.map(el1 => {
					api.evaluation_sheet
						.getLatest(0, { subject_id: el1.id })
						.then(res => {
							this.student.evaluationData = res
						})
						.catch(err => {})
				})

				// 索取列表
				this.$api.evaluation_sheet.list(0).then(res => {
					if (res.data.length <= 0) return

					this.currentEvaluation = res.data[0]

					this.allSemester = res.data.map(el => {
						return {
							value: '' + el.year + '_' + el.semester,
							label: '' + el.year + '学年' + (el.semester == 1 ? '上学期' : '下学期'),
							subject_id: el.subject_id
						}
					})

					//默认选中第一个学期
					this.student.currentEvaluationTable = this.allSemester[0].value

					this.onChangeSubjectTable()
				})

				break
			}
			case this.$api.account.types.TEACHER.value: {
				this.quickActions = [
					{
						to: {
							name: 'personalCenter'
						},
						title: '个人中心',
						background: '#21A74A'
					},
					{
						to: {
							name: 'studentPerformance'
						},
						title: '学生表现',
						background: '#35C1B1'
					}
				]
				break
			}
			case this.$api.account.types.SCHOOL_ADMIN.value: {
				this.quickActions = [
					{
						to: {
							name: 'personalCenter'
						},
						title: '个人中心',
						background: '#21A74A'
					}
				]
				break
			}
			case this.$api.account.types.BUREAU_ADMIN.value: {
				this.quickActions = [
					{
						to: {
							name: 'personalCenter'
						},
						title: '个人中心',
						background: '#21A74A'
					}
				]
				break
			}
		}
	},
	methods: {
		async onChangeEvaluationTable(selected) {
			let res = selected.split('_')
			let year = res[0]
			let semester = res[1]

			this.student.year = year
			this.student.semester = semester

			let evalTbl = await this.$api.evaluation_sheet.get(0, year, semester, {
				subject_id: this.student.currentSubjectTable
			})

			this.student.evaluationData = evalTbl
		},
		async onChangeSubjectTable() {
			//根据当前学科获取指标表
			this.student.evalationTables = this.allSemester.filter(el => {
				return el.subject_id === this.student.currentSubjectTable
			})

			//切换学科时，学期默认第一个
			if (this.student.evalationTables.length != 0) {
				this.student.currentEvaluationTable = this.student.evalationTables[0].value
				this.onChangeEvaluationTable(this.student.evalationTables[0].value)
			} else {
				this.student.currentEvaluationTable = '无评估表'
				this.student.evaluationData = null
			}
		}
	}
}
</script>

<style lang="scss">
.banner-img {
	border-radius: 8px;
	width: 1050px;
	height: 170px;
	object-fit: cover;
	object-position: center center;
	display: block;
	margin-bottom: 20px;
}

.quickaction {
	margin-top: 20px;
}

.stat-numbers {
	height: 120px;
	margin-top: 10px;
	.number-block {
		height: 120px;
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: center;
		font-size: 50px;
		transition: all 0.3s;

		.caption {
			text-align: center;
			font-size: 14px;
		}
	}

	.number-block-class {
		color: #2093a7;
	}

	.number-block-student {
		color: #4d7fde;
	}

	.number-block-test {
		color: #409eff;
	}

	.number-block-declaration {
		color: #f36666;
	}
}

.stat-numbers.common {
	.number-block {
		background-color: white;
		border-radius: 8px;
		padding: 0 30px;
		text-align: left;
		justify-content: end;

		&:hover {
			box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
		}
		.caption {
			font-size: 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 20px;

			svg {
				font-size: 12px;
			}
		}

		p {
			line-height: normal;
			margin: 0;
			display: flex;

			span {
				font-size: 16px;
				margin-left: 10px;
				margin-top: 30px;
				opacity: 0.5;
			}
		}
	}
}

.todo-block {
	margin-top: 10px;
}

.evaluation-sheet-block {
	border-radius: 8px;

	tbody,
	thead {
		tr {
			td:nth-child(1),
			th:nth-child(1) {
				padding-left: 0;
			}
			td:last-child {
				padding-right: 0;
			}
		}
	}
}
</style>
